const appName = {
  dev: 'Orbital-dev',
  production: 'Orbital',
};

const sideBarItems = [
  {
    name: 'Ganymede',
    displayName: 'Time Machine',
    iconName: 'comparison',
    items: ['Manage', 'Explorer', 'Prices'],
  },
  {
    name: 'Europa',
    displayName: 'Analytics',
    iconName: 'timeline-line-chart',
    items: ['Sales & Attendance'],
  },
  {
    name: 'Sales',
    displayName: 'Sales Analytics',
    iconName: 'tag',
    items: [
      'Sales and Attendance',
      'Sales - S',
      'Sales - S - All Years',
      'Sales - XL',
      'Sales By SOR - S',
      'Sales By SOR - S - All Years',
      'Sales By SOR - XL',
    ],
  },
  {
    name: 'Attendance',
    displayName: 'Attendance Analytics',
    iconName: 'walk',
    items: ['Attendance - S', 'Attendance - S - All Years', 'Attendance - XL'],
  },
  {
    name: 'DCO',
    displayName: 'DCO Analytics',
    iconName: 'flash',
    items: ['Sales & Bookings'],
  },
  {
    name: 'Web',
    displayName: 'Web Analytics',
    iconName: 'globe-network',
    items: ['Web Traffic', 'Web Traffic - Page Visits', 'Web Traffic - Page Landings', 'Email'],
  },
  {
    name: 'Io',
    displayName: 'Utilities',
    iconName: 'cog',
    items: ['SK Utility'],
  },
  // {
  //   name: 'Admin',
  //   displayName: 'Admin',
  //   iconName: 'lock',
  //   items: ['Users'],
  // },
];

const demoMode = false;

const buildNumberReset = process.env.REACT_APP_STAGE === 'production' ? 65 : 207;

export { appName, sideBarItems, demoMode, buildNumberReset };
